// extracted by mini-css-extract-plugin
module.exports = {"block_item":"itemContct_block_item__T1xcw","images":"itemContct_images__39dFh"};